<template lang="pug">
    //- Barra de filtros de búsqueda
    .b2b-filters
        b2b-search-bar
            div.header(slot='header')
                span.dateHeader {{ $t('invoices.filters.creation_date.value') }}
                ods-date-picker(
                    v-model='dateTimePickerValue',
                    type='datetimerange',
                    :picker-options='pickerOptions2',
                    @change='getDateTimePickerValue',
                    :range-separator='$t("msg_generics.datepicker.separator")',
                    :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                    :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                    :format='$t("date_format_long_datepicker")',
                    :canSelectSeconds='true',
                    clearIcon='',
                    :default-time="['00:00:00', '23:59:59']",
                    prefix-icon='prefix-icon-date-time-picker',
                    :showFooterButtons='true',
                    align='right')
                ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
                  ods-button(
                      icon='ods-icon-refresh',
                      size='medium',
                      @click="activeRefreshResults")
                ods-tooltip.ods-ml-4(:content='$t("issues.dialog_add_issue.button_add_tooltip")', placement='bottom')
                  ods-button(
                      v-if='canAdminIndra || canCreateIssue'
                      size='medium',
                      icon='ods-icon-upload'
                      @click.native='handleNewIssue')
                      | {{ $t('issues.dialog_add_issue.button_add') }}
            div(slot='body')
                ods-form.b2b-filters__area(
                    :model='filterForm',
                    :rules='rules',
                    ref='filterForm',
                    @submit.native.prevent='')

                    ods-form-item.first-input(prop='firstValue')
                        ods-select(
                            :no-match-text='$t("msg_generics.no_match")',
                            v-model='filterForm.firstValue',
                            :placeholder='$t("msg_generics.advanced_search")',
                            @change='getFirstValue')
                            ods-option(
                                v-for='option in options',
                                :key='option.col',
                                :label='$t(option.value)',
                                :disabled='option.selected',
                                :value='option')
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show='filterForm.firstValue')
                        //- Select type
                        div(v-if="(selected.componente === 'select')")
                            ods-form-item.others-input(prop='secondValueSelect')
                                ods-select(v-if="selected.prop === 'idProject'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in selected.options',
                                        :key='option.id',
                                        :label='option.name',
                                        :value='option.id')
                                ods-select(v-else-if="selected.prop === 'issueTypeId'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='(option, index) in selected.options',
                                        :key='option.id',
                                        :label='$t("issue.type." + option.issueType)',
                                        :value='option.id')
                                ods-select(v-else-if="selected.prop === 'statusId'"
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  filterable,
                                  :placeholder='$t(selected.placeholder)',
                                  @change='getSecondValue')
                                  ods-option(
                                    v-for='(option, index) in selected.options',
                                    :key='option.id',
                                    :label='$t("issue.status." + option.status)',
                                    :value='option.id')
                                ods-select(v-else-if="selected.prop === 'priorityId'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in selected.options',
                                        :key='option.value',
                                        :label='option.label',
                                        :value='option.value')
                                ods-select(v-else-if='selected.prop === "buyerId"',
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  filterable,
                                  :filter-method='filterParties',
                                  :placeholder='$t(selected.placeholder)',
                                  @change='getSecondValue')
                                  ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                                ods-select(v-else-if='selected.prop === "sellerId"',
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  filterable,
                                  :filter-method='filterParties',
                                  :placeholder='$t(selected.placeholder)',
                                  @change='getSecondValue')
                                  ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                                ods-select(v-else
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                      v-for='option in selected.options',
                                      :key='option.id',
                                      :label='formatterLabel(option.code)',
                                      :value='option.id')
                        //- Asunto
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'summary')")
                         ods-form-item.others-input(prop='summary')
                                ods-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model.trim='filterForm.summary',
                                    @input='getSecondValue')
                        div(v-else)
                            ods-form-item(prop='secondValue')
                                ods-input.others-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.secondValue',
                                    @input='getSecondValue')
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show='filterForm.firstValue')
                        ods-button(
                          icon='ods-icon-plus',
                          size='medium',
                          circle,
                          @click.native="onSubmit('filterForm')")

        .b2b-filters__container(v-if='listSelectedFiltersIssues.length > 0')
          transition-group.b2b-filters__group(
            name='ods-fade-in-linear',
            tag='div')
            ods-popover(
              key='icon-delete-filters',
              placement='top-start',
              trigger='hover',
              :content='$t("msg_generics.popover_clean_filters")')
              ods-button.clean-filters(
                slot='reference',
                type='neutral',
                size='small',
                icon='ods-icon-delete',
                @click='handleDeleteAllFilters')

            .b2b-filters__button(
              v-for='(filter, index) in listSelectedFiltersIssues',
              :key='index')
              b2b-filter-button-issues(
                :filter='filter',
                @closeTag='resetSelectedOneOption')
        ods-dialog(
          ref='dialogAddIssue',
          :title='$t("issues.dialog_add_issue.title")',
          :visible.sync='isShowDialogAddIssue',
          :append-to-body='true',
          @close='handleCloseDialog',
          width='40%')
          ods-form(
            ref='formDialogAddIssue',
            :rules='rulesDialogAddIssue',
            :model='formDialogAddIssue',
            size='mini')
            ods-row(type='flex')
              ods-col(:span='11')
                ods-form-item(
                  :label='$t("issues.dialog_add_issue.form_add.type")'
                  prop='issueType')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='formDialogAddIssue.issueType',
                    filterable,
                    :placeholder='$t("issues.dialog_add_issue.form_add.type")')
                    ods-option(
                      v-for='option in optionsFilterTypeIssue',
                      :key='option.id',
                      :label='$t("issue.type." + option.issueType)',
                      :value='option.id')
                ods-form-item(
                  v-if='!activeUser.data.projects || (activeUser.data.projects && activeUser.data.projects.length > 1)',
                  :label='$t("issues.dialog_add_issue.form_add.project")',
                  prop='issueProject')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    @change='onChangeProject',
                    v-model='formDialogAddIssue.issueProject',
                    filterable,
                    clearable,
                    :placeholder='$t("issues.dialog_add_issue.form_add.project")')
                    ods-option(
                      v-for='option in optionsFilterService',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                ods-form-item(
                  :label='$t("issues.dialog_add_issue.form_add.seller")'
                  prop='issueSeller')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='formDialogAddIssue.issueSeller',
                    filterable,
                    :filter-method='filterSeller',
                    :placeholder='$t("issues.filters.seller.placeholder")')
                    ods-option(
                      v-for='option in this.optionsSeller' ,
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
              ods-col(:span='2')
              ods-col(:span='11')
                ods-form-item(
                  :label='$t("issues.dialog_add_issue.form_add.priority")'
                  prop='issuePriority')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='formDialogAddIssue.issuePriority',
                    filterable,
                    :placeholder='$t("issues.dialog_add_issue.form_add.priority")')
                    ods-option(
                      v-for='option in this.optionsPriority' ,
                      :key='option.value',
                      :label='option.label',
                      :value='option.value')
                ods-form-item(
                  :label='$t("issues.dialog_add_issue.form_add.buyer")'
                  prop='issueBuyer')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='formDialogAddIssue.issueBuyer',
                    filterable,
                    :filter-method='filterBuyer',
                    :placeholder='$t("issues.filters.buyer.placeholder")')
                    ods-option(
                      v-for='option in this.optionsBuyer' ,
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
                ods-form-item(
                  :label='$t("issues.dialog_add_issue.form_add.subject")',
                  prop='issueSummary')
                  ods-input(
                    v-model='formDialogAddIssue.issueSummary')
            ods-row
                ods-form-item(
                  :label='$t("issues.dialog_add_issue.form_add.description")',
                  prop='issueDescription')
                  ods-input(
                    type='textarea',
                    v-model='formDialogAddIssue.issueDescription')
          span.dialog-footer(slot='footer')
            ods-button(
              type='primary',
              @click.native='onSubmitAddIssue("formDialogAddIssue")')
              | {{ $t('msg_generics.load_document') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonIssues from './B2bFilterButtonIssues'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-issues',
  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },
  mixins: [Utils],
  components: {
    B2bSearchBar,
    B2bFilterButtonIssues
  },

  data () {
    const _this = this
    return {
      // DatePicker
      dateTimePickerValue: [],
      filterDatePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },

      tid: null,
      idProject: null,

      // Forumlario
      filterForm: {
        firstValue: '',
        secondValue: '',
        secondValueSelect: [],
        summary: ''
      },
      formDialogAddIssue: {
        issueType: null,
        issuePriority: null,
        issueProject: null,
        issueBuyer: null,
        issueSeller: null,
        issueSummary: null,
        issueDescription: null
      },
      selected: {},
      selectedFilters: [],
      options: {},
      auxListParties: [],
      optionsBuyer: [],
      optionsSeller: [],
      optionsPriority: [
        { value: 1, label: this.$t('issue.priority.value_1') }, { value: 2, label: this.$t('issue.priority.value_2') }, { value: 3, label: this.$t('issue.priority.value_3') }],

      // Reglas Validación
      rules: {
        summary: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') },
          { max: 100, message: this.$t('msg_generics.max_num_character', { max: 40 }), trigger: 'change' }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ]
      },
      // Reglas Validación
      rulesDialogAddIssue: {
        issueType: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        issuePriority: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        issueProject: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        issueBuyer: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        issueSeller: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        issueSummary: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { max: 100, message: this.$t('validations.maxlenght', { maxlenght: 100 }), trigger: 'change' }
        ],
        issueDescription: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ]
      },
      servicios: [],
      isShowDialogAddIssue: false
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'queryIssues',
      'listSelectedFiltersIssues',
      'optionsFilterService',
      'optionsFilterEmitter',
      'optionsFilterReceiver',
      'optionsFilterStatusIssue',
      'optionsFilterBuyerIssue',
      'optionsFilterSellerIssue',
      'optionsFilterSummaryIssue',
      'optionsFilterDateCreationIssue',
      'optionsFilterPriorityIssue',
      'optionsFilterTypeIssue',
      // Permisos
      'canAdminIndra',
      'canCreateIssue',
      'urlIn'
    ])
  },

  watch: {
    $route (to) {
      this.listSelectedFiltersIssues = this.listSelectedFiltersIssues // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getIssues',
      'newIssue',
      'queryIssuesState',
      'listSelectedFiltersIssuesState',
      'getOptionsFilterTypeIssue',
      'getOptionsFilterStatusIssue',
      'getOptionsFilterPartyME',
      'getOptionsFilterPartyMEFenixBackend',
      'optionsFilterReceiverState',
      'getOptionsService',
      'optionsServicesEnabledState',
      'optionsFilterEmitterState',
      'optionsFilterServiceState',
      'optionsFilterStatusIssueState',
      'optionsFilterTypeIssueState'

    ]),

    formatterLabel (code) {
      const type = this.selected.prop
      let key
      switch (type) {
        case 'statusId':
          key = 'issue.status.'
          break
        case 'invoiceTypeId':
          key = 'issue.type.'
          break
      }
      return this.$t(key + code)
    },

    async getFirstValue (data) {
      this.filterForm.summary = ''
      this.filterForm.secondValue = ''
      this.filterForm.secondValueSelect = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
      this.optionsFilterReceiverState([])
      this.optionsFilterEmitterState([])
    },
    getSecondValue (data) {
      if (this.selected.componente === 'select' && this.selected.prop === 'idProject') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.issueType
      } else if (this.selected.componente === 'select' && this.selected.prop === 'issueTypeId') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = this.$t('issue.type.' + option.issueType)
      } else if ((this.selected.componente === 'select' && this.selected.prop === 'sellerId') ||
        (this.selected.componente === 'select' && this.selected.prop === 'buyerId')) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.tradeName
        this.selected.partyId = this.selected.labelText
      } else if ((this.selected.componente === 'select' && this.selected.prop === 'statusId')) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = this.$t('issue.status.' + option.status)
      } else if (this.selected.componente === 'select' && this.selected.prop === 'priorityId') {
        const option = this.selected.options.find(function (elem) {
          return elem.value === data
        })
        this.selected.query = option.value
        this.selected.labelText = option.label
      } else if (this.selected.componente === 'select') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = this.formatterLabel(option.code)
      }
      if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      }
      this.$refs.filterForm.clearValidate()
    },

    async handleNewIssue () {
      this.isShowDialogAddIssue = true
    },

    // Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogAddIssue.resetFields()
    },
    onChangeProject (data) {
      this.formDialogAddIssue.issueBuyer = null
      this.formDialogAddIssue.issueSeller = null

      this.optionsBuyer = []
      this.optionsSeller = []
    },
    onSubmitAddIssue (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_issue')
          })
          try {
            const query = {
              projectId: this.formDialogAddIssue.issueProject,
              buyerId: this.formDialogAddIssue.issueBuyer,
              sellerId: this.formDialogAddIssue.issueSeller,
              issueTypeId: this.formDialogAddIssue.issueType,
              priority: this.formDialogAddIssue.issuePriority,
              summary: this.formDialogAddIssue.issueSummary,
              description: this.formDialogAddIssue.issueDescription
            }
            await this.newIssue(query)

            this.$notify({
              title: this.$t('msg_generics.upload_issue_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.refreshResults()
          } catch (error) {
            console.log('onSubmitAddIssue CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddIssue = false
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },
    onSubmit (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop
            console.log('column ', column)
            switch (column) {
              case 'buyerId':
                this.queryIssues.buyerId = this.selected.query
                break
              case 'sellerId':
                this.queryIssues.sellerId = this.selected.query
                break
              case 'idProject':
                this.queryIssues.projectId = this.selected.query
                this.idProject = this.selected.query
                break
              case 'statusId':
                this.queryIssues.status = this.selected.query
                break
              case 'description':
                this.queryIssues.description = this.selected.query
                break
              case 'summary':
                this.queryIssues.summary = this.selected.query
                break
              case 'priorityId':
                this.queryIssues.priority = this.selected.query
                break
              case 'issueTypeId':
                this.queryIssues.issueTypeId = this.selected.query
                break
              case 'id':
                this.queryIssues.id = this.selected.query
                break
              default:
                break
            }
            this.selectedFilters = this.listSelectedFiltersIssues
            console.log('FILTROS SELECCIONADOS: ', this.selectedFilters)
            console.log('queryIssues: ', this.queryIssues)

            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersIssuesState(
              this.selectedFilters
            )

            this.selected = {}
            this.$refs[formName].resetFields()
            this.filterForm.filterDatePickerValue = []

            await this.queryIssuesState(this.queryIssues)
            dataQuery.query = this.queryIssues
            const response = await this.getIssues(dataQuery)
            this.totalResults = response.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        }
      })
    },

    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })

      try {
        await this.queryIssuesState(this.queryIssues)
        dataQuery.query = this.queryIssues
        const response = await this.getIssues(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('refreshResults CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getDateTimePickerValue () {
      if (!this.dateTimePickerValue) {
        this.dateTimePickerValue = []
        this.dateTimePickerValue.push(this.queryIssues.creationDateTimeFrom)
        this.dateTimePickerValue.push(this.queryIssues.creationDateTimeTo)
      } else {
        this.queryIssues.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryIssues.creationDateTimeTo = this.dateTimePickerValue[1]
      }
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_date')
      })

      try {
        await this.queryIssuesState(this.queryIssues)
        dataQuery.query = this.queryIssues
        await this.getIssues(dataQuery)
      } catch (error) {
        console.log('getDateTimePickerValue CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Filtro Fechas Incidencias
    getDateRangePickerValue () {
      console.log('getDatePickerValue: ', this.filterDatePickerValue)
      this.selected.query = this.filterDatePickerValue
      this.getSecondValue(this.selected)
    },

    async activateUpload () {
      const dataQueryService = { page: 0, size: 1000, enabled: true, sort: 'name,ASC' }
      const result = await this.getOptionsService(dataQueryService)
      await this.optionsFilterServiceState(result)
      this.isShowDialogAddInvoice = true
    },
    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })

      try {
        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
        await this.listSelectedFiltersIssuesState([])
        this.selectedFilters = this.listSelectedFiltersIssues.map(
          item => {
            item.labelText = ''
            item.query = ''
            item.selected = false
            return item
          }
        )
        await this.listSelectedFiltersIssuesState(
          this.selectedFilters
        )

        if (!this.dateTimePickerValue) {
          this.queryIssues.creationDateTimeFrom = ''
          this.queryIssues.creationDateTimeTo = ''
        } else {
          this.queryIssues.creationDateTimeFrom = this.dateTimePickerValue[0]
          this.queryIssues.creationDateTimeTo = this.dateTimePickerValue[1]
        }

        this.queryIssues.buyerId = ''
        this.queryIssues.sellerId = ''
        this.queryIssues.status = ''
        this.queryIssues.id = ''
        this.queryIssues.priority = ''
        this.queryIssues.summary = ''
        this.queryIssues.projectId = ''
        this.queryIssues.issueTypeId = ''
        this.queryIssues.description = ''
        this.idProject = ''

        await this.queryIssuesState(this.queryIssues)
        dataQuery.query = this.queryIssues
        await this.getIssues(dataQuery)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },

    async getPartiesResults (data) {
      let role = ''
      if (this.filterForm.firstValue.prop === 'buyerId') {
        role = 'BUYER'
      } else {
        role = 'SELLER'
      }
      const requestParty = {
        role: role,
        projectId: [this.idProject],
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
      console.log('response parties ', response)
      this.selected.options = response
      console.log('response this.selected.options ', this.selected.options)
      this.auxListParties = response
      console.log('response this.auxListParties ', this.auxListParties)
    },
    async getPartiesResultsBuyer (data) {
      const role = 'BUYER'

      const requestParty = {
        role: role,
        projectId: [this.formDialogAddIssue.issueProject],
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
      this.optionsBuyer = response
    },
    async getPartiesResultsSeller (data) {
      const role = 'SELLER'

      const requestParty = {
        role: role,
        projectId: [this.formDialogAddIssue.issueProject],
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
      this.optionsSeller = response
    },

    async filterParties (data) {
      let role = ''
      if (this.filterForm.firstValue.prop === 'buyerId') {
        role = 'BUYER'
      } else {
        role = 'SELLER'
      }
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        } else { // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.auxListParties = []
          if (role === 'BUYER') {
            this.optionsFilterReceiverState(this.auxListParties)
          } else {
            this.optionsFilterEmitterState(this.auxListParties)
          }
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async filterBuyer (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResultsBuyer, 1000, data)
        } else { // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.auxListParties = []
          this.optionsFilterReceiverState(this.auxListParties)
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async filterSeller (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResultsSeller, 1000, data)
        } else { // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.auxListParties = []
          this.optionsFilterEmitterState(this.auxListParties)
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 404:
        case 409:
        case 415:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersIssuesState(data.listAfterRemove)
      this.initForm()
    },

    initForm () {
      if (!this.options.asunto.selected) {
        this.filterForm.firstValue = this.options.asunto
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    }
  },

  async created () {
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersIssues)

    // Si no tiene el permiso SEARCH_CHANNEL quitamos el filtro de canal
    if (this.activeUser.data.projects && this.activeUser.data.projects.length < 2) {
      delete this.options.servicio
    }

    this.initForm()
    if (this.queryIssues.creationDateTimeFrom) {
      this.dateTimePickerValue.push(this.queryIssues.creationDateTimeFrom)
      this.dateTimePickerValue.push(this.queryIssues.creationDateTimeTo)
    }

    // Si solo tiene un proyecto asociado el usuario, cargamos ese proyecto en el combo
    // de cargar issue
    if (this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
      this.formDialogAddIssue.issueProject = this.activeUser.data.projects[0].id
    }
    try {
      await this.queryIssuesState(this.queryIssues)
      await this.getOptionsFilterStatusIssue()
      await this.getOptionsFilterTypeIssue()
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    this.options.comprador.options = this.optionsFilterReceiver
    this.options.vendedor.options = this.optionsFilterEmitter

    if (this.optionsFilterService.length > 1 && this.options.servicio) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.estado.options = this.optionsFilterStatusIssue
    this.options.tipo_incidencia.options = this.optionsFilterTypeIssue
    this.options.prioridad.options = this.optionsPriority
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-select__tags {
  margin-top: rem(20) !important;
}
::v-deep .b2b-filters__area .ods-form-item input {
  margin-bottom: rem(20) !important;
  height: 32px !important;
}
::v-deep .ods-select .ods-input.is-focus .ods-input__inner {
  height: 32px !important;
}
::v-deep .ods-input__prefix {
  height: 72px !important;
}
.ods-select {
  ::v-deep .ods-input__suffix {
    height: 72px !important;
  }
}
::v-deep .ods-select__caret {
  padding-top: 40px;
}
.b2b-filters {
  ::v-deep .ods-input__suffix {
    height: 114px !important;
  }
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-icon-plus {
  margin-left: 10px;
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }

  .ods-button {
    display: inline;
    margin-right: rem(24);
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
